import { CONFIG_NAME } from "./enums";

export default {
  name: CONFIG_NAME.BASE,
  profileId: null,
  sdkIntegration: {
    version: "1.73.0",
    integrity:
      "sha384-4g6qXnKATkC6Iq4q/w1qWgEQLOo8UbMQBLAGeicj3e52N4PBLA9Uyhwizd5QfCCP",
  },
  sdkAuth: {
    inbentaKey: null,
    domainKey: null,
  },
  sdkConfig: {
    chatbotId: null,
    environment: null,
    showLoader: true,
    inputCharacterCounter: true,
    inputCharacterCounterMax: 100,
    forms: {
      errorRetries: 3,
      allowUserToAbandonForm: true,
    },
    closeButton: { visible: true },
    answers: {
      maxRelatedContents: 5,
      maxOptions: 5,
    },
    lang: "es",
    labels: {
      es: {
        "interface-title": "SKY",
        "close-chat":
          "¿Desea cerrar el chat? <p>Se perderá el histórico de la conversación</p>",
      },
    },
    variables: [],
    ratingPosition: "conversationWindow",
    ratingOptions: [
      { id: 1, label: "Sí", comment: false, response: "¡Gracias!" },
      { id: 2, label: "No", comment: true },
    ],
  },
  appConfig: {
    instance: null,
    context: null,
    salesforceConf: {
      instance: null,
      endpoints: {
        staging: null,
        production: null,
      },
    },
  },
};
